import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import type { IconProps } from '../../primitives/types.js';

export function IcnUndo(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="undo">
      <path d="M3 7h7a3 3 0 1 1 0 6H7" />
      <path d="M5 4L3 7l2 3" />
    </Svg>
  );
}
